import { reactive } from 'vue';
import type { Props as ItemProps, Props, Style } from '@/components/core/notice/item/types';
import Core from '@/core/core/core';
import { genIntHash } from '@/core/utils/string';

export const transitionDuration = 300;

export type Item = Props & { onClose?: Function };

export const itemById = reactive(new Map<string, Item>());

const genItemId = (text: ItemProps['text'], style: ItemProps['style'], options?: Options) => {
	return 'top-notice_' + genIntHash(text + style + JSON.stringify(options));
};

export type Options = {
	title?: ItemProps['title'],
	metaText?: ItemProps['metaText'],
	buttonProps?: ItemProps['buttonProps'],
	buttonsProps?: ItemProps['buttonsProps'],
	isSafeHTML?: ItemProps['isSafeHTML'],
	selectToClose?: ItemProps['selectToClose'],
	onClose?: Function
}

/**
 * Показать сообщением в стиле push уведомления
 *
 * title будет получен из первой строки text
 *
 * Если в options указан title, он будет взят оттуда
 */
export const show = (text: string, style: Style = 'info', options?: Options) => {
	let title = '';

	text = String(text);

	const id = genItemId(text, style, options);

	if (options?.title) {
		title = options.title;
	} else {
		const chunks = text.split('\n');

		if (chunks.length) {
			title = String(chunks.shift());
			text = chunks.join('\n');
		}
	}

	const itemExists = itemById.get(id);
	if (itemExists) {
		hightlight(itemExists);

		return;
	}

	const item: Item = {
		id,
		title,
		text,
		style,
		buttonProps: options?.buttonProps,
		buttonsProps: options?.buttonsProps,
		metaText: options?.metaText,
		isSafeHTML: options?.isSafeHTML,
		selectToClose: options?.selectToClose,
		onClose: options?.onClose,
	};

	itemById.set(item.id, item);

	if (itemById.size > 5) {
		const [_firstId, firstItem] = [...itemById].at(0) || [];
		if (firstItem) close(firstItem);
	}

	/**
	 * Автозакрытие ошибок форм
	 *
	 * Добавляет
	 */
	if (Core.state.isMobile) {
		$('input').one('click', () => close(item));
	}
};

const hightlight = (item: Item) => {
	item.hightlight = true;

	setTimeout(() => item.hightlight = false, transitionDuration);
};

const close = (item: Item) => {
	item.forceClosed = true;

	setTimeout(() => {
		item.onClose?.();

		itemById.delete(item.id);
	}, transitionDuration);
};

/**
 * Убрать подозрительный html код
 */
export const prepareText = (text: string) => {
	const textNoSafety = 'hacking was detected';

	text = text.replace(/<script/g, textNoSafety);
	text = text.replace(/<img/g, textNoSafety);
	text = text.replace(/<iframe/g, textNoSafety);
	text = text.replace(/javascript:/g, textNoSafety);
	text = text.replace(/<[^>]+ (@|on)\w+=[^>]+>?/g, textNoSafety);

	return text;
};
